import { styled, Tabs, withStyles, Tab } from '@material-ui/core';

//Static container here makes sure that any element added below need not consider the fixed position element.
export const StaticContainer = styled('div')({
  width: '100%',
  height: '64px',
});

//Fixed and static container should have the same height.
export const FixedContainer = styled('div')(({ sidebar, theme }) => ({
  top: 64, //length of top-bar
  position: 'fixed',
  left: sidebar ? theme.dimension.sideBarWidth : 0,
  width: sidebar ? `calc(100% - ${theme.dimension.sideBarWidth}px)` : '100%',
  borderBottom: `solid 1px ${theme.palette.common.inputBorder}`,
  background: theme.palette.xpl.background,
  zIndex: 1000,
  height: '61px',
}));

export const ScrollTabs = withStyles((theme) => ({
  scrollButtons: {
    width: '40px',
  },
  indicator: {
    backgroundColor: theme.palette.xpl.primary.default,
  },
}))(Tabs);

export const ScrollTab = styled(Tab)(({ theme }) => ({
  fontSize: '14px',
  minHeight: '60px',
  '& span': {
    color: theme.palette.common.darkerText,
  },
  fontFamily: theme.typography.fontFamily,
  textTransform: 'none',
  opacity: 0.7,
}));
